export default {
  path: 'sys_dept',
  name: 'sys_dept',
  component: () => import('@/pages/sys_dept/SysDeptList'),
  meta: { title: '部门管理' },
}
